import React from "react";
import { Routes, Route } from "react-router-dom";

const DefaultLayout = React.lazy(() => import("../../Layout/DefaultLayout"));
const ProtectedRoute = React.lazy(() =>
  import("../../ProtectedRoute/ProtectedRoute")
);
const Login = React.lazy(() => import("../../Pages/Login/Login"));
const Register = React.lazy(() => import("../../Pages/Register/Register"));
const ForgotPassword = React.lazy(() =>
  import("../../Pages/ForgotPassword/ForgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("../../Pages/ResetPassword/ResetPassword")
);

const RootNavigator = () => {
  return (
    <>
      <Routes>
        <Route
          path="*"
          name="Home"
          element={<ProtectedRoute Component={DefaultLayout} />}
        />
        <Route exact path="/login" name="Login Page" element={<Login />} />
        <Route
          exact
          path="/register"
          name="Register Page"
          element={<Register />}
        />
        <Route
          exact
          path="/forgotpass"
          name="Forgotpass Page"
          element={<ForgotPassword />}
        />
        <Route
          exact
          path="/reset-password"
          name="Reset-Password"
          element={<ResetPassword />}
        />
      </Routes>
    </>
  );
};

export default RootNavigator;
